/**
 * Shop Home page color definitions
 */
import { palette, createColor } from './palette.colors';

export const shopHomeColors = {
  mainBackground: createColor(palette.blue.appBG, palette.dark.background),
  background: createColor(palette.gray.backgroundLight, palette.gray.backgroundLight),
  border: createColor(palette.gray.iconLight, palette.dark.techBorder),
  headerText: createColor(palette.gray.veryDark, palette.gray.veryDark),
  helpText: createColor(palette.gray.mediumShade, palette.gray.mediumShade),
  logoBorder: createColor(palette.gray.lightBorder2, palette.gray.lightBorder2),
  searchArrowBg: createColor(palette.gray.backgroundLight, palette.gray.backgroundLight),
  welcomeTitleText: createColor(palette.blue.onTint, palette.gray.white),
  welcomeSubtitleText: createColor(palette.gray.lightDarkGrey, palette.gray.disabledBG),
  textColor: createColor(palette.gray.darker, palette.dark.textAlt),
  textDarkColor: createColor(palette.blue.onTint, palette.gray.white),
  cardBackground: createColor(palette.gray.white, 'transparent'),
  iconBackground: createColor(palette.gray.iconLight, palette.gray.iconLight),
  technicianNameText: createColor(palette.blue.onTint, palette.gray.white),
  technicianRoleText: createColor(palette.blue.onTint, palette.gray.slateLight),
  // WCAG 1.4.3: was palette.gray.dark (#707070, 4.48:1 vs white – fails AA for small text) → palette.gray.zinc (#6B7280) gives 4.6:1
  technicianLocationText: createColor(palette.gray.lightDarkGrey, palette.gray.tabDisabled),
  logoBackground: createColor(palette.ui.linkBlue, palette.ui.linkBlue),
  ellipsisBG: createColor(palette.blue.sky, palette.blue.sky),
  ellipsisColor: createColor(palette.gray.darkest, palette.gray.darkest),
  logoText: createColor(palette.gray.white, palette.gray.white),
  filterBorderColor: createColor(palette.borders.dropdownBlue, 'transparent'),
  cardBorderColor: createColor(palette.borders.dropdownBlue, palette.gray.lightDarkGrey),
  filterBackground: createColor(palette.gray.white, palette.blue.softBlue),
  filterSelectedTextColor: createColor(palette.blue.onTint, palette.gray.white),
  workOrderSortBorder: createColor(palette.gray.border, palette.dark.borderLight),
  workOrderSortSelectedText: createColor(palette.gray.darkest, palette.gray.white),
  workOrderSelectedTextColor: createColor(palette.blue.onTint, palette.gray.white),
  sortIcon: createColor(palette.blue.onTint, palette.gray.white),
  logoutCTABorder: createColor(palette.gray.border, palette.dark.techBorder),
  logoutCTAIcon: createColor(palette.blue.onTint, palette.gray.white),
  logoutCTAText: createColor(palette.gray.darkest, palette.dark.text),
  languageIconColor: createColor(palette.blue.onTint, palette.gray.white),
  pageMessageIcon: createColor(palette.blue.primary, palette.blue.primary),
  workOrdeViewBorder: createColor(palette.gray.pureDark, palette.gray.pureDark),
  newUpdateButtonBG: createColor(palette.blue.primary, palette.blue.primary),
  newUpdateButtonText: createColor(palette.gray.white, palette.gray.white),
};